export default "__VITE_ASSET__mgJQOwBi__"